
const getBaseUrl = () => {
  // In case the host is checkleaked.com, replace the checkleaked.cc in the url with checkleaked.com
  if (window.location.hostname === 'checkleaked.com') {
    return process.env.VUE_APP_BASE_URL.replace('checkleaked.cc', 'checkleaked.com');
  }
  return process.env.VUE_APP_BASE_URL;
}

const config = {
  baseUrl: getBaseUrl(),
  baseUrlAlt: 'https://checkleaked.cc/api',
  recaptchaKey: '6LcTNcMUAAAAALfLcgD0y-A5e6t4vefcFNdeH5ED'
};

export default config;
